module.exports = __webpack_public_path__ + "static/media/map.d4531081.svg";